module.exports = __webpack_public_path__ + "media/yu.b622560d.mp3";